/**
 * @file: utils.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { VehicleMediaQueryParams } from '@euler/app/flows/record/functions/useServiceRecordMedias';

export const getMediasPageTitleByQueryParams = (
  params: VehicleMediaQueryParams,
) => {
  return (
    (params.target.type === 'mileage'
      ? `${params.target.mileage}公里`
      : `${params.target.year}年${params.target.month}月`) +
    `${params.current ? ' - 当前' : ''}`
  );
};
